import { View, Text, TouchableOpacity, Image } from 'react-native';
import React from 'react';
import { restaurantStyles } from '../styles/restaurant';
import Dot from 'react-native-vector-icons/Entypo';
import LocationPin from 'react-native-vector-icons/Entypo';
import { useNavigation } from '@react-navigation/native';
import { useDispatch } from 'react-redux'; 
import { addItem } from '../../Redux/actions'; 

const restaurants = [
  {
    image_url:
      'https://img.freepik.com/free-photo/top-view-pepperoni-pizza-with-mushroom-sausages-bell-pepper-olive-corn-black-wooden_141793-2158.jpg?w=996&t=st=1688081597~exp=1688082197~hmac=d2ce9e05f6327f73d2b292163c92944c1c10a55a0ece58a80ec74c2663bda0b5',
    title: 'Pizza Kings',
    rating: 5,
    genre: 'Pizza',
    price: 1250,
    address: 'Parklands',
    description:
      'Savor the classic flavors of pepperoni, mushroom, sausage, bell pepper, olive, corn, and black wooden-fired perfection in this irresistible pizza delight',
    dishes: [],
    lon: 12,
    lat: 5,
  },
  {
    image_url:
      'https://img.freepik.com/free-photo/grilled-chicken-legs-flaming-grill-with-grilled-vegetables-with-tomatoes-potatoes-pepper-seeds-salt_1150-37782.jpg?w=1380&t=st=1689092051~exp=1689092651~hmac=220a8599ac247113bb2e75e385052ec1cf3f4b71105deb972d8c199dc6018db7',
    title: 'Chicken Choma',
    rating: 5,
    genre: 'Grilled Chicken',
    price: 750,
    address: 'Mombasa Rd  ',
    description:
      'Grilled chicken sizzles, releasing tantalizing aromas. Golden-brown, charred skin entices. Tender, juicy bites burst with smoky, savory flavors, leaving lingering satisfaction.',
    dishes: [],
    lon: 12,
    lat: 5,
  },
  {
    image_url:
      'https://img.freepik.com/free-photo/side-view-rice-garnish-with-grilled-chicken-cucumber-carrot-bell-pepper-spring-onion_141793-5070.jpg?w=996&t=st=1688082564~exp=1688083164~hmac=865b563feb825525bd3b415d122c8b155a721d6493a5c61dba9274c2630e13bd',
    title: 'Swahili Dishes',
    rating: 5,
    genre: 'Mchele Mnazi',
    price: 550,
    address: 'Westlands Rd',
    description:
      'Steaming white rice serves as the bed for succulent grilled chicken, topped with a delightful garnish of fragrant coconut, creating a harmonious blend of flavors and textures.',
    dishes: [],
    lon: 12,
    lat: 5,
  },
];

const RestaurantCard = () => {
 const navigation = useNavigation();
 const dispatch = useDispatch();

 const handleRestaurantSelection = (restaurant) => {
 
   dispatch(addItem(restaurant));
   navigation.navigate('Popup', { restaurant }); 
 };

  return (
    <>
      {restaurants.map((restaurant, index) => (
        <TouchableOpacity
          style={restaurantStyles.rcard}
          key={index}
          onPress={() => handleRestaurantSelection(restaurant)}>
          <View style={restaurantStyles.cardwrapper}>
            <Image
              source={{ uri: restaurant.image_url }}
              style={restaurantStyles.dishPic}
            />
            <View style={restaurantStyles.textArea}>
              <View>
                <Text style={restaurantStyles.brand}>{restaurant.title}</Text>
              </View>
              <View style={restaurantStyles.rate}>
                <Text style={restaurantStyles.genre}>
                  <Text>{restaurant.rating}</Text>
                  <Dot name="dot-single" />
                  {restaurant.genre}
                </Text>
                <Text style={restaurantStyles.price}>
                  Ksh. {restaurant.price}
                </Text>
              </View>
              <View style={restaurantStyles.location}>
                <LocationPin name="location-pin" style={restaurantStyles.pin} />
                <Text style={restaurantStyles.lText}>
                  Nearby
                  <Dot name="dot-single" />
                  {restaurant.address}
                </Text>
              </View>
            </View>
          </View>
        </TouchableOpacity>
      ))}
    </>
  );
};

export { RestaurantCard, restaurants };
